import React, { memo } from 'react';
import HintWrapper from '../HintWrapper';
import './SubnauticaCreaturesHint.scss';

const SubnauticaCreaturesHint = memo(({ attemptsCount, currentCreature, gameWon, isHintRevealed, onRevealHint }) => {
  return (
    <HintWrapper
      attemptsCount={attemptsCount}
      currentItem={currentCreature}
      gameWon={gameWon}
      isHintRevealed={isHintRevealed}
      onRevealHint={onRevealHint}
      cssPrefix="subnautica-creatures-game"
      hintProperty="description"
      hintLabel="Description"
      showPostWinHint={true}
      unlockThreshold={5}
    >
      {/* Custom content renderer for description */}
      {currentCreature && currentCreature.description && (
        <>
          <div><strong>Description:</strong></div>
          <div className="subnautica-creatures-game__hint-creature-description">{currentCreature.description}</div>
        </>
      )}
    </HintWrapper>
  );
});

export default SubnauticaCreaturesHint;